export * from './useMaizy';
export * from './useMaizyChart';
export * from './usePrecocityClassOptionsList';
import isNil from 'lodash-es/isNil';
export var MaizyState;
(function (MaizyState) {
    MaizyState[MaizyState["good"] = 0] = "good";
    MaizyState[MaizyState["medium"] = 1] = "medium";
    MaizyState[MaizyState["bad"] = 2] = "bad";
})(MaizyState || (MaizyState = {}));
export const getSoilTemperatureState = (pastState, futureState) => {
    const isFutureStateGood = futureState === MaizyState.good;
    const isPastStateGood = pastState === MaizyState.good;
    const isPastStateMedium = pastState === MaizyState.medium;
    const isFutureStateMedium = futureState === MaizyState.medium;
    if (isNil(futureState) || isNil(pastState))
        return null;
    if (isPastStateGood && isFutureStateGood)
        return MaizyState.good;
    if ((isPastStateMedium && isFutureStateGood) ||
        (isPastStateMedium && isFutureStateMedium) ||
        (isPastStateGood && isFutureStateMedium))
        return MaizyState.medium;
    return MaizyState.bad;
};
export const fields = {
    dryMatterTarget: {
        min: 28,
        max: 40,
        step: 1,
        defaultValue: 32
    }
};
export const constants = {
    // Calendar legends
    dayWithoutRainThreshold: 2, // mm
    soilTemperatureStateGoodTemperatureThreshold: 12, // °C
    soilTemperatureStateBadTemperatureThreshold: 10 // °C
};
